/**
 * StaffPortalBaseService
 * Base service for Staff Portal operations.
 * All staff portal services extend this for consistent URL building and HTTP methods.
 */
/**
 * Abstract base service for staff portal endpoints.
 */
export class StaffPortalBaseService {
    constructor(http, config) {
        this.http = http;
        this.servicePath = config.servicePath;
        this.basePath = config.basePath;
        this.endpointOverrides = config.endpoints ?? {};
    }
    /**
     * Get the endpoint path, checking for overrides
     */
    getEndpoint(key, defaultPath) {
        return this.endpointOverrides[key] ?? defaultPath;
    }
    /**
     * Build the full URL path for an endpoint
     */
    buildUrl(endpoint) {
        const parts = [];
        if (this.servicePath) {
            parts.push(this.servicePath);
        }
        parts.push(this.basePath);
        if (endpoint) {
            parts.push(endpoint);
        }
        const url = '/' + parts.join('/').replace(/\/+/g, '/').replace(/^\//, '');
        return url;
    }
    /**
     * Build URL with query parameters
     */
    buildUrlWithParams(endpoint, params) {
        const url = this.buildUrl(endpoint);
        if (!params) {
            return url;
        }
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value !== undefined && value !== null) {
                searchParams.append(key, String(value));
            }
        });
        const queryString = searchParams.toString();
        return queryString ? `${url}?${queryString}` : url;
    }
    /**
     * Make a GET request
     */
    async get(endpoint) {
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    /**
     * Make a POST request
     */
    async post(endpoint, body) {
        const url = this.buildUrl(endpoint);
        return this.http.post(url, body);
    }
    /**
     * Make a PUT request
     */
    async put(endpoint, body) {
        const url = this.buildUrl(endpoint);
        return this.http.put(url, body);
    }
    /**
     * Make a PATCH request
     */
    async patch(endpoint, body) {
        const url = this.buildUrl(endpoint);
        return this.http.patch(url, body);
    }
    /**
     * Make a DELETE request
     */
    async delete(endpoint) {
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
//# sourceMappingURL=StaffPortalBaseService.js.map